import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f23b3350")

_pushScopeId("data-v-f23b3350")
const _hoisted_1 = { class: "economic-sectors-list flex flex--v flex--width flex--valign-c flex--gap-40" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_economic_sectors'),
    "title-id": 'economic-sectors-page',
    gap: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.decoratedEconomicSectors, (sector) => {
          return (_openBlock(), _createBlock("div", {
            key: sector.id,
            class: "economic-sectors-list-entry flex flex--width flex--valign-c flex--gap-50"
          }, [
            _createVNode("div", {
              class: ["image-circle image-circle--left", { hidden: sector.isOdd }]
            }, [
              _createVNode("img", {
                src: 'imgs/' + sector.name + '.jpg',
                class: "d-block"
              }, null, 8, ["src"])
            ], 2),
            _createVNode("div", {
              class: ["economic-sectors-list-entry-content flex--extend flex flex--v flex--valign-s flex--gap-10", { 'flex--valign-s': sector.isEven, 'flex--valign-e': sector.isOdd }]
            }, [
              _createVNode("span", {
                class: ["economic-sectors-list-entry-text text text--uppercase text--primary-b text--size-22 text--semi-bold", { 'text--right': sector.isOdd }]
              }, _toDisplayString(_ctx.$trans("company." + sector.name)), 3),
              _createVNode("span", {
                class: ["economic-sectors-list-entry-text text text--accent-gray-b text--size-20 text--medium", { 'text--right': sector.isOdd }]
              }, _toDisplayString(_ctx.$trans("company." + sector.name + "_desc")), 3)
            ], 2),
            _createVNode("div", {
              class: ["image-circle image-circle--right", { hidden: sector.isEven }]
            }, [
              _createVNode("img", {
                src: 'imgs/' + sector.name + '.jpg',
                class: "d-block"
              }, null, 8, ["src"])
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})